import * as React from "react";
const SvgFiRrFaceSunglasses = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-sunglasses_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 2c3.728 0 6.98 2.054 8.699 5.086a3 3 0 0 0-.7-.086h-4.085a4.37 4.37 0 0 0-2.765 1h-2.298a4.37 4.37 0 0 0-2.765-1H4.001c-.239 0-.473.032-.7.086C5.021 4.054 8.273 2 12 2m0 20c-5.294 0-9.629-4.139-9.967-9.349A4 4 0 0 0 5.021 14h2.137a3.994 3.994 0 0 0 3.881-3.03l.242-.97h1.439l.242.97A3.994 3.994 0 0 0 16.843 14h2.137a4 4 0 0 0 2.987-1.349C21.629 17.861 17.294 22 12 22m5.746-6.664a1 1 0 0 1-.08 1.409c-.103.092-2.559 2.254-5.666 2.254s-5.563-2.162-5.666-2.254a1 1 0 0 1 1.33-1.493C7.689 15.274 9.672 17 12 17s4.316-1.73 4.336-1.748a1 1 0 0 1 1.41.084"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-sunglasses_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSunglasses;
